(function () {
  var wrap = document.querySelector('[data-hero-payments]');
  var select = document.querySelector('[data-hero-payment-select]');
  if (!wrap || !select) return;

  var labelMap = {
  'one time purchase': 'Full Payment',
  '2 monthly payments': '2 Monthly Payments',
  '3 monthly payments': '3 Monthly Payments',
  '4 monthly payments': '4 Monthly Payments',
  '6 monthly payments': '6 Monthly Payments',
  '9 monthly payments': '9 Monthly Payments'
};
  function shortLabel(text) {
    var key = text.trim().toLowerCase();
    return labelMap[key] || text.trim();
  }

  // Loop only computes each plan's price after the radio is interacted with.
  // Same "hydration" trick used elsewhere: click each one, then restore.
  function hydrateLoopPrices() {
    var radios = Array.from(document.querySelectorAll('input[name="loop_purchase_option"]'));
    if (!radios.length) return false;
    var original = radios.find(function (r) { return r.checked; }) || radios[0];
    radios.forEach(function (r) {
      if (r !== original) { try { r.click(); } catch (e) {} }
    });
    setTimeout(function () {
  try { original.click(); } catch (e) {}
  setTimeout(function () {
    populateDropdown();
  }, 400);
}, 80);
    return true;
  }

  function findPriceElFor(radio) {
    if (radio.id && radio.id.indexOf('loop-one-time-purchase') === 0) {
      return document.querySelector('#loop-price-one-time');
    }
    var variantId = radio.dataset.variantId;
    var groupId = radio.dataset.id;
    if (variantId && groupId) {
      return document.querySelector('#loop-price-' + variantId + '-' + groupId);
    }
    return null;
  }

  function populateDropdown() {
    var entries = [];

    var oneTimeRadio = document.querySelector('input[id^="loop-one-time-purchase-"]');
    if (oneTimeRadio) {
      var oneTimeLabelEl = document.querySelector('.loop-one-time-purchase-option-label');
      entries.push({
        radio: oneTimeRadio,
        label: oneTimeLabelEl ? oneTimeLabelEl.textContent : 'One time Purchase'
      });
    }

    // Only pull subscription radios from the currently active variant block
    var activeBlock = null;
    var blocks = document.querySelectorAll('[id^="loop-product-variant-"]');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].style.display !== 'none') { activeBlock = blocks[i]; break; }
    }
    if (!activeBlock && blocks.length) activeBlock = blocks[0];

    if (activeBlock) {
      activeBlock.querySelectorAll('.loop-subscription-group-radio').forEach(function (radio) {
        var grp = radio.closest('.loop-subscription-group');
        var labelText = grp ? grp.querySelector('.loop-subscription-group-label') : null;
        entries.push({
          radio: radio,
          label: labelText ? labelText.textContent : (radio.dataset.name || '')
        });
      });
    }

    if (!entries.length) return;

    // Rebuild the dropdown options
    select.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select a payment plan';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    entries.forEach(function (entry, idx) {
      var priceEl = findPriceElFor(entry.radio);
      var priceText = priceEl ? priceEl.textContent.trim() : '';
      var opt = document.createElement('option');
      opt.value = String(idx);
      opt.textContent = shortLabel(entry.label) + (priceText ? ',  ' + priceText : '');
      opt.dataset.radioSelector = buildRadioSelector(entry.radio);
      select.appendChild(opt);
    });

    select.disabled = false;
    wrap.removeAttribute('hidden');
  }

  // Build a stable selector we can use later to re-find the exact radio
  function buildRadioSelector(radio) {
    if (radio.id) return '#' + CSS.escape(radio.id);
    var variantId = radio.dataset.variantId;
    var groupId = radio.dataset.id;
    if (variantId && groupId) {
      return '.loop-subscription-group-radio[data-variant-id="' + variantId + '"][data-id="' + groupId + '"]';
    }
    return null;
  }

 select.addEventListener('change', function () {
  var opt = select.options[select.selectedIndex];
  if (!opt || !opt.dataset.radioSelector) return;
  var radio = document.querySelector(opt.dataset.radioSelector);
  if (radio) {
    try { radio.click(); } catch (e) {}
  }
  if (typeof window.scrollToEnrollIstt === 'function') {
    window.scrollToEnrollIstt();
  }
});

  // Wait for Loop's radios to appear, then hydrate
  var attempts = 0;
  var ready = setInterval(function () {
    attempts++;
    if (document.querySelector('input[name="loop_purchase_option"]')) {
      hydrateLoopPrices();
      clearInterval(ready);
    }
    if (attempts > 60) clearInterval(ready);
  }, 250);
})();